import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';

import { APP_PATH, API_PATH } from '@app/app.constants';
import { AUTH_TOKEN } from '@app/_interceptors/auth.interceptor';
import { AccountService } from '@teacher/services/account.service';
import { APIService } from '@app/_services/api.service';
import { GROUPS } from '@app/app.constants';
import { ResponseGroups, ResponseMain } from '@app/_interfaces/responses';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private token: string | null = null;

    constructor(private router: Router, private accountService: AccountService, private api: APIService) {
        this.token = localStorage.getItem(AUTH_TOKEN);
    }

    getGroups(): Observable<ResponseGroups> {
        return this.api.get(API_PATH.people.groups);
    }

    get isLoggedIn(): boolean {
        return !!this.token;
    }

    // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
    login(formData): Observable<any> {
        return this.api.post(API_PATH.login, formData);
    }

    loginAdmin(formData): Observable<ResponseMain> {
        return this.api.post(API_PATH.admin.login, formData);
    }

    signup(formData): Observable<any> {
        return this.api.post(API_PATH.signup, formData);
    }

    logout() {
        this.api.get(API_PATH.logout).subscribe();
        this.resetAuth();
        this.accountService.clearTeacher();
        this.router.navigate([APP_PATH.login]);
    }

    resetAuth() {
        sessionStorage.clear();
        localStorage.removeItem('token');
        localStorage.removeItem('profile');
        localStorage.removeItem('userPhoto');
        localStorage.removeItem('CURRENT_GROUP_ID');
        window.document.cookie.split(';').forEach(function(c) {
            document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
        });
        this.token = null;
    }

    checkUserInfo(profile): boolean {
        const emptyInformations = [];
        const isDefaultParent = profile.user.email.split('_');
        const isParentGroup = profile.group.name === GROUPS.PARENT;

        if (isParentGroup) {
            if (!profile.user.first_name) {
                emptyInformations.push('Имя');
            }

            if (!profile.user.last_name) {
                emptyInformations.push('Фамилия');
            }

            if (isDefaultParent[1] === 'parent' || !profile.user.email) {
                emptyInformations.push('email');
            }

            if (emptyInformations.length) {
                return true;
            }
        }

        return false;
    }
}
